module.exports = __webpack_public_path__ + "static/media/hdi-pin.ff97eaba.svg";